import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { TranslateService } from './core/services/translate.service';
import { LanguageService } from './core/services/language.service';
import { AppConfigService } from './core/services/app-config.service';

export function initTranslations(translate: TranslateService, lang: LanguageService) {
  return () => translate.loadLang(lang.currentLang).toPromise();
}

export function initAppConfig(appConfigService: AppConfigService) {
  return () => appConfigService.load();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [TranslateService, LanguageService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAppConfig,
      deps: [AppConfigService],
      multi: true
    }
  ]
};
